import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const api = axios.create({ baseURL: config.baseUrl });

api.interceptors.request.use((cfg) => {
  const token = Cookies.get('token');
  if (token) cfg.headers['Authorization'] = `Bearer ${token}`;
  return cfg;
});

// Trae los oid_poblacion del participante (array de números)
export const getPoblacionesParticipante = async (oid_participante) => {
  try {
    const response = await api.get(`/api/poblacion-participante/${oid_participante}`);
    return { status: response.status, data: response.data };
  } catch (error) {
    return { status: error.response?.status || 500, data: [] };
  }
};

// Guarda (crea o reemplaza) las poblaciones del participante
export const guardarPoblacionesParticipante = async (oid_participante, oid_poblaciones) => {
  try {
    const response = await api.post('/api/poblacion-participante', {
      oid_participante,
      oid_poblaciones
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    return { status: error.response?.status || 500, message: 'Error guardando poblaciones' };
  }
};